import '../App.css';
const Contact = () => {
	return (
		<div>
		<main>
			<div class="container contacts">
				<div class="bgcontacts">
					<div class="header-title center"><h1>GET IN TOUCH<br/>TODAY</h1></div>
					<div class="treelists-cont" style={{ justifyContent: 'space-around'}}>
						<div class="treelists-c-itm">
							<div class="treelists-c-title">adress</div>
							<div class="treelists-c-datas" style={{ textAlign: 'center' }}><span class="fcicon adr-icon"></span>www.simssolutions.net <br />Muscat - Bawshar</div>
						</div>

						<div class="treelists-c-itm">
							<div class="treelists-c-title">mail</div>
							<div class="treelists-c-datas"><span class="fcicon mail-icon"></span>Ayman.r.alkhaldi@gmail.com</div>
						</div>

						<div class="treelists-c-itm">
							<div class="treelists-c-title">Phone number</div>
							<div class="treelists-c-datas"><span class="fcicon phone-icon"></span>95168133</div>
						</div>
					</div>
				</div>
				<div>
					<br />
					<p style={{ fontSize: '16px' }}>
						Don't wait for a safer and more efficient tomorrow; make it happen today! Join the SIMS Solutions revolution and experience the power of AI-driven safety and management. Visit our website or contact us now to schedule a personalized demo and take the first step toward a future where safety, efficiency, and success go hand in hand. Your journey to a smarter, safer tomorrow begins here! 
					</p>
					<br />
					<p style={{ fontStyle: 'italic', fontSize: '18px' }}><strong>Discover the future of safety and efficiency with SIMS SOLUTIONS.</strong></p>
				</div>
			</div>
		</main>
	</div>
		  )
}
export default Contact;
